module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_64-012d7d1d2cb92e02b3739802e961756e.png";